import { render, staticRenderFns } from "./SidebarClientTemplate.vue?vue&type=template&id=a7663b20&scoped=true"
import script from "./SidebarClientTemplate.vue?vue&type=script&lang=js"
export * from "./SidebarClientTemplate.vue?vue&type=script&lang=js"
import style0 from "./SidebarClientTemplate.vue?vue&type=style&index=0&id=a7663b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7663b20",
  null
  
)

export default component.exports